import React from 'react'
import PropTypes from 'prop-types'

import T from 'T'
import HHAccordion from 'components/common/HHAccordion'
import LocationsList from '../content/location/list/LocationsList'

const LocationsPanel = ({
  customerDetails,
  accountId,
  selectedLocationId,
  onLocationChange,
  onLocationStatusChange,
  onSaveTags,
  isMobile,
}) => {
  if (isMobile) {
    return (
      <HHAccordion
        withNewColors
        isExpanded
        summary={T.LOCATIONS}
        sx={{
          padding: 1,
          '& .MuiAccordionDetails-root': {
            maxHeight: '50vh',
            overflow: 'auto',
          },
        }}
      >
        <LocationsList
          customerDetails={customerDetails}
          accountId={accountId}
          selectedLocationId={selectedLocationId}
          onLocationChange={onLocationChange}
          onLocationStatusChange={onLocationStatusChange}
          onSaveTags={onSaveTags}
          showAddLocationIcon
        />
      </HHAccordion>
    )
  }

  return (
    <LocationsList
      customerDetails={customerDetails}
      accountId={accountId}
      selectedLocationId={selectedLocationId}
      onLocationChange={onLocationChange}
      onLocationStatusChange={onLocationStatusChange}
      onSaveTags={onSaveTags}
      showAddLocationIcon
    />
  )
}

LocationsPanel.propTypes = {
  customerDetails: PropTypes.object.isRequired,
  accountId: PropTypes.string.isRequired,
  selectedLocationId: PropTypes.string,
  onLocationChange: PropTypes.func.isRequired,
  onLocationStatusChange: PropTypes.func.isRequired,
  onSaveTags: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
}

export default LocationsPanel
